import type { OpenWindowParams } from "./OsAppRegistry";
import { openUrlInOsContext } from "./openUrl";

/**
 * Opens a relative or absolute URL as an OS window when the route maps to a
 * registered app. Returns true when handled; false when callers should fall back
 * (e.g. window.open or navigate).
 */
export function tryOpenUrlInOsMode(
  openWindow: ((config: OpenWindowParams) => void) | undefined,
  url: string,
  options?: { title?: string },
): boolean {
  return openUrlInOsContext(openWindow, url, { title: options?.title });
}
